import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from '../../state/reducers';
import {Router} from '@angular/router';
import * as ProductActions from './actions';
import {getCurrentPractice} from '../../practices/state/selectors';
import {catchError, map, mergeMap, withLatestFrom} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {Noop} from '../../state/actions';
import {of} from 'rxjs';
import {DefaultWhatsappTemplate} from "../../models/DefaultWhatsappTemplate";
import { PmsProduct } from '../../interfaces/pms-product.interface';
import { ProductsService } from '../products.service';

@Injectable()
export class ProductsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private router: Router,
    private messageService: MessageService,
    private productsService: ProductsService,
  ) {}

  getProducts$ = createEffect(() => this.actions$.pipe(
    ofType(ProductActions.GetProducts),
    withLatestFrom(this.store.select(getCurrentPractice)),
    mergeMap(([action, practice]) => {
      return this.productsService.getProducts(practice)
        .pipe(
          map((result: PmsProduct[]) => {
            return ProductActions.GetProductsSuccess({products: result});
          }),
          catchError(() => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'An error occurred when getting products',
              life: 5000
            });
            return of(ProductActions.GetProductsFail());
          })
        );
    })
  ));
}
